import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { toast } from 'react-toastify'
import request from 'src/utils/request'

const initialState = {
  isLoading: false,
  isSuccess: false,
  universityData: [],
  error: '',
}

export const getUniversitiesList = createAsyncThunk(
  'university/getUniversitiesList',
  async (_, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res = await request(token).get(`/tables/university`)
      const data = await res.data
      return data
    } catch (err) {
      toast.error(err.response.data)
      return thunkAPI.rejectWithValue(err.response.data)
    }
  },
)

export const deleteUniversity = createAsyncThunk(
  'university/deleteUniversity',
  async ({ childrenProps, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res1 = await request(token).delete(`/tables/university`, {
        data: childrenProps.selected,
      })
      const dt = await res1.data
      toast.success(
        lang === 'Français'
          ? dt?.rowDeleted + ' université(s) supprimée(s) avec succès'
          : dt?.rowDeleted + ' university(ies) deleted successfully',
      )
      const res = await request(token).get(`/tables/university`)
      const data = await res.data
      return data
    } catch (err) {
      const message =
        lang === 'Français'
          ? 'Erreur ! ' +
            err.response.data.errorCount +
            ' sur ' +
            childrenProps.selected.length +
            " université(s) n'ont pas pu être supprimées"
          : 'Error ! ' +
            err.response.data.message.errorNum +
            ' of ' +
            childrenProps.selected.length +
            ' university(ies) could not be deleted'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const insertUniversity = createAsyncThunk(
  'university/insertUniversity',
  async ({ currentUniversity, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res1 = await request(token).post(`/tables/university`, { data: currentUniversity })
      const message =
        lang === 'Français' ? 'Université ajoutée avec succès' : 'University added successfully'
      toast.success(message)
      const res = await request(token).get(`/tables/university`)
      const data = await res.data
      return data
    } catch (err) {
      const message =
        lang === 'Français'
          ? 'Erreur ' +
            err.response.data.message.errorNum +
            " ! L'université n'a pas pu être ajoutée"
          : 'Error ' + err.response.data.message.errorNum + ' ! The university could not be added'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const updateUniversity = createAsyncThunk(
  'university/updateUniversity',
  async ({ currentUniversity, lang }, thunkAPI) => {
    try {
      const token = await thunkAPI.getState().auth.user.token
      const res1 = await request(token).put(`/tables/university`, { data: currentUniversity })
      const message =
        lang === 'Français'
          ? res1.data.rowUpdated + ' université(s) modifiée(s) avec succès'
          : res1.data.rowUpdated + ' university(ies) updated successfully'
      toast.success(message)
      const res = await request(token).get(`/tables/university`)
      const data = await res.data
      return data
    } catch (err) {
      const message =
        lang === 'Français'
          ? err.response.data.rowUpdated + ' université(s) mise(s) à jour avec succès'
          : err.response.data.rowUpdated + ' university(ies) updated successfully'
      toast.error(message)
      return thunkAPI.rejectWithValue(message)
    }
  },
)

export const universitySlice = createSlice({
  name: 'university',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUniversitiesList.pending, (state) => {
        return {
          ...state,
          isLoading: true,
        }
      })
      .addCase(getUniversitiesList.fulfilled, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: true,
          universityData: action.payload,
          error: '',
        }
      })
      .addCase(getUniversitiesList.rejected, (state, action) => {
        return {
          ...state,
          isLoading: false,
          isSuccess: false,
          error: action.error.message,
        }
      })
      .addCase(insertUniversity.pending, (state, action) => {
        return {
          ...state,
        }
      })
      .addCase(insertUniversity.fulfilled, (state, action) => {
        return {
          ...state,
          universityData: action.payload,
        }
      })
      .addCase(insertUniversity.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          error: action.payload,
        }
      })
      .addCase(updateUniversity.pending, (state, action) => {
        return {
          ...state,
        }
      })
      .addCase(updateUniversity.fulfilled, (state, action) => {
        return {
          ...state,
          universityData: action.payload,
        }
      })
      .addCase(updateUniversity.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          error: action.payload,
        }
      })
      .addCase(deleteUniversity.pending, (state, action) => {
        return {
          ...state,
        }
      })
      .addCase(deleteUniversity.fulfilled, (state, action) => {
        return {
          ...state,
          isSuccess: true,
          universityData: action.payload,
        }
      })
      .addCase(deleteUniversity.rejected, (state, action) => {
        return {
          ...state,
          isSuccess: false,
          error: action.payload,
        }
      })
  },
})

export default universitySlice.reducer
